import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { PermissionService } from '../services/permission.service';

// Posé sur /app : charge les droits avant que la sidebar et les pages ne se
// construisent. Laisse toujours passer — un compte sans droit voit un Admin
// vide plutôt qu'une redirection en boucle.
export const loadPermissionsGuard: CanActivateFn = async () => {
  await inject(PermissionService).ensureLoaded();
  return true;
};

// Posé sur une route qui déclare `data: {permission: 'domaine:action'}`.
export const hasPermissionGuard: CanActivateFn = async (route) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  await permissionService.ensureLoaded();

  const permission = route.data?.['permission'] as string | undefined;
  if (!permission || permissionService.has(permission)) {
    return true;
  }
  return router.createUrlTree(['/app/dashboard']);
};
